<template>
  <v-app id="inspire">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-col cols="8" class="mx-auto text-center">
          <section>
            <v-img
              :src="require('@/assets/imgs/logo.svg')"
              fluid
              class="mx-auto"
              width="30%"
            ></v-img>
          </section>
        </v-col>
        <v-col class="mx-auto" cols="12" sm="8">
          <v-form @submit.prevent="handleLogin">
            <v-card-text class="px-0">
              <form-group
                name="email"
                :validator="$v.email"
                attribute="fields.email"
              >
                <template slot-scope="{ attrs }">
                  <v-text-field
                    outlined
                    rounded
                    v-bind="attrs"
                    v-model="email"
                    placeholder="Enter your mail"
                    @input="$v.email.$touch()"
                    type="email"
                  >
                  </v-text-field>
                </template>
              </form-group>

              <form-group
                name="password"
                :validator="$v.password"
                attribute="fields.password"
                class="mt-5"
              >
                <template slot-scope="{ attrs }">
                  <v-text-field
                    outlined
                    rounded
                    v-bind="attrs"
                    v-model="password"
                    placeholder="Enter your password"
                    @input="$v.password.$touch()"
                    type="password"
                  >
                  </v-text-field>
                </template>
              </form-group>
            </v-card-text>
            <v-card-actions class="px-0">
              <div class="flex-grow-1"></div>
              <v-btn
                :loading="loading"
                width="100%"
                class="text-capitalize"
                rounded
                large
                color="primary"
                type="submit"
              >
                <strong>{{ $t("form_box.login") }}</strong></v-btn
              >
            </v-card-actions>
          </v-form>
        </v-col>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, email } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  validations: {
    email: { required, email },
    password: {
      required,
      minLength: minLength(6),
    },
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  data() {
    return {
      email: "",
      password: "",
      loading: false,
      redirect: undefined,
    };
  },
  methods: {
    handleLogin() {
      if (this.$v.$invalid) {
        return;
      } else {
        this.loading = true;
        let data = {
          email: this.email,
          password: this.password,
        };
        this.$store
          .dispatch("LoginByEmail", data)
          .then(() => {
            this.$router.push({ path: this.redirect || "/users" });
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
